export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          关于古古
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          了解古古漫画网的故事与使命
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/70 p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-book-read-line text-xl text-primary-500" />
              </div>
              <span className="text-xl font-heading font-bold text-primary-500">古古漫画网</span>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              <strong className="text-foreground-900">古古漫画网</strong> 创立于 2018 年，是国内领先的免费漫画在线阅读平台。
              我们致力于为漫画爱好者提供最优质的阅读体验，首创下拉式阅读模式，让追漫变得更轻松、更沉浸。
              从最初的几百部作品起步，如今已成长为覆盖日漫、韩漫、国漫三大品类的综合性漫画平台。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              目前平台已收录超过 <strong className="text-primary-500">两万部</strong> 漫画作品，
              涵盖热血、恋爱、耽美、悬疑、奇幻、搞笑、校园、都市等数十种风格标签。
              每日有超过 <strong className="text-primary-500">三百万</strong> 漫迷在古古漫画网上享受免费阅读，
              每周超过两千话新内容入库更新。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们与多家汉化组和内容创作者保持紧密合作，坚持 <strong className="text-foreground-900">免费、纯净、高速</strong> 的理念，
              为读者打造一个没有弹窗广告、没有强制跳转的沉浸式漫画阅读空间。
              支持夜间模式、字号调节和横竖屏切换，让每一位漫迷都能找到最舒适的阅读方式。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              未来古古漫画网将继续拓展内容库，引入更多优质漫画作品，
              并持续优化下拉式阅读体验，让更多好看的漫画触手可及。
              感谢每一位漫迷的支持与陪伴，古古漫画网将不忘初心，始终做你追漫路上最可靠的伙伴。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}